import { View } from 'react-native';
import { WordSquare } from './index';

export function WordSquareContainer({ word, correctWords }) {
  return (
    <View className="flex-[1.5] items-center p-2">
      <View className="flex-1 bg-white">
        <WordSquare word={word} correctWords={correctWords} />
      </View>
    </View>
  );
}
